module.exports = __webpack_public_path__ + "static/media/comment-slash.708a9d23.svg";